import Rollbar from 'rollbar';
import { APP_CONFIG } from './app';
export const IGNORED_MESSAGES = [`Your rate limit has been reached for access token "post_client_item".`, '(unknown): ResizeObserver loop limit exceeded', 'ResizeObserver loop limit exceeded'];

// Error handling using rollbar
// https://rollbar.com/docs/notifier/rollbar.js/configuration
const config = {
  accessToken: APP_CONFIG.ROLLBAR_API_KEY,
  captureUncaught: true,
  captureUnhandledRejections: true,
  hostSafeList: ['mangools.com', 'mnglsbeta.com'],
  payload: {
    environment: APP_CONFIG.APP_ENV,
    client: {
      source_map_enabled: true,
      code_version: APP_CONFIG.APP_VERSION,
      guess_uncaught_frames: true
    }
  },
  ignoredMessages: IGNORED_MESSAGES,
  // Never mask the customer's search input in Rollbar items — no `scrubFields` for `kw`, `keyword`,
  // `domain`, `query` or the like, and no other redaction of it. Without the search term a failure
  // cannot be reproduced. #218 added exactly that and it was removed on purpose; do not bring it back.
  // The SDK's default scrubbing of passwords and tokens is unaffected.
  // The login redirect and the /system/me request carry the session ticket and login token in the
  // URL; the SDK adds these to its defaults and blanks their values in URLs, telemetry and payloads.
  scrubFields: ['sso_ticket', 'login_token']
};
const rollbar = Rollbar.init(config);
export default rollbar;